import React from "react";

// App crash ho to white screen ki jagah ye screen dikhegi.
// Pehli baar crash par khud cache + purana saved data saaf karke ek baar reload karta hai.
// Dobara crash ho to error ke saath "Fix & Reload" button dikhata hai.

const AUTO_FLAG = "gooil_autofix_done";

export async function repairApp(keepLogin) {
  try {
    if ("serviceWorker" in navigator) {
      const regs = await navigator.serviceWorker.getRegistrations();
      await Promise.all(regs.map((r) => r.unregister()));
    }
  } catch (e) {}
  try {
    if (window.caches) {
      const keys = await caches.keys();
      await Promise.all(keys.map((k) => caches.delete(k)));
    }
  } catch (e) {}
  if (!keepLogin) {
    try { localStorage.clear(); } catch (e) {}
  }
  try { sessionStorage.clear(); } catch (e) {}
}

export default class AppErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null, busy: false };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("App crashed:", error, info && info.componentStack);
    let already = false;
    try { already = sessionStorage.getItem(AUTO_FLAG) === "1"; } catch (e) {}
    if (!already) {
      this.setState({ busy: true });
      repairApp(true).then(() => {
        try { sessionStorage.setItem(AUTO_FLAG, "1"); } catch (e) {}
        window.location.replace("/");
      });
    }
  }

  handleFix = () => {
    this.setState({ busy: true });
    repairApp().then(() => {
      try { sessionStorage.setItem(AUTO_FLAG, "1"); } catch (e) {}
      window.location.replace("/");
    });
  };

  render() {
    if (!this.state.error) return this.props.children;

    const msg = String((this.state.error && (this.state.error.message || this.state.error)) || "");
    const box = {
      minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center",
      padding: 16, background: "#f8fafc", fontFamily: "system-ui, sans-serif",
    };
    const card = {
      maxWidth: 380, width: "100%", background: "#fff", borderRadius: 12, padding: 24,
      boxShadow: "0 4px 20px rgba(0,0,0,0.08)", textAlign: "center",
    };
    const btn = {
      marginTop: 16, width: "100%", padding: "12px 16px", border: 0, borderRadius: 8,
      background: "#16a34a", color: "#fff", fontSize: 16, fontWeight: 600,
    };

    if (this.state.busy) {
      return (
        <div style={box}><div style={card}>
          <h2 style={{ margin: 0, fontSize: 18 }}>Updating app…</h2>
          <p style={{ color: "#64748b", fontSize: 14 }}>Please wait a few seconds.</p>
        </div></div>
      );
    }

    return (
      <div style={box}><div style={card}>
        <h2 style={{ margin: 0, fontSize: 18 }}>Something went wrong</h2>
        <p style={{ color: "#64748b", fontSize: 14 }}>
          Tap the button below. The app will clear old data and open again. You may need to log in again.
        </p>
        <button style={btn} onClick={this.handleFix}>Fix &amp; Reload</button>
        <p style={{ marginTop: 16, color: "#94a3b8", fontSize: 11, wordBreak: "break-word" }}>
          Error: {msg.slice(0, 200)}
        </p>
      </div></div>
    );
  }
}
